import { useTranslations } from '@vocab/react';
import { Stack, Strong, Text } from 'braid-design-system';
import { observer } from 'mobx-react';

import type { IFilterQuestion } from 'src/stores/JobApplicationStore/FiltersStore/FiltersStore';

import translations from './.vocab/';
import { CheckboxRow } from './CheckboxRow';

interface Props {
  question: IFilterQuestion;
  onSelect: () => void;
}

export const CheckboxFilterAnswers = observer(
  ({ question, onSelect }: Props) => {
    const { t } = useTranslations(translations);

    return (
      <Stack space="medium">
        {question.showPreferredAnswersMessage && (
          <Text tone="secondary" size="xsmall">
            {t('Your matching answers are preselected', {
              Strong: (children) => (
                <Strong key={`${children}`}>{children}</Strong>
              ),
            })}
          </Text>
        )}

        {question.answersToDisplay.map((answer) => (
          <CheckboxRow
            isPreferred={answer.answerInfo.isPreferred}
            key={answer.answerInfo.globalIdOrId}
            count={answer.count}
            text={answer.answerInfo.text}
            id={answer.answerInfo.globalIdOrId}
            isSelected={answer.isSelected}
            disabled={answer.disabled}
            onSelect={() => {
              answer.onToggleAnswerSelected();
              onSelect();
            }}
          />
        ))}
      </Stack>
    );
  },
);
